import { fetchArray } from "entity";
import { useState, useEffect } from "react";
import RodadaEntity from "..";



/**
 * Hook para consultar uma rodada pelo UID.
 * @param {string|number} rodadaId - UID da rodada a ser consultada.
 * @returns {{ rodada: any|null, loading: boolean }}
 */
export function useRodada(rodadaUid) {
    const [rodada, setRodada] = useState();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;
        setLoading(true);
        const fetchRodada = async () => {
            let query = await RodadaEntity.where("uid", "==", rodadaUid);
            const result = await fetchArray(query.get());
            const rodada = result[0] || null;
            if (isMounted) {
                setRodada(rodada);
                setLoading(false);
            }
        };
        if (rodadaUid) fetchRodada();
        else {
            setRodada(null);
            setLoading(false);
        }
        return () => { isMounted = false; };
    }, [rodadaUid]);

    return { rodada, loading };
}